import angular from 'angular';
import ImageModalComponent from './image-modal.component';

const ImageModalModule = angular
    .module('control-room.commons.content.components.image-uploader.components.image-modal', [])
    .component('crImageModal', ImageModalComponent);

export default ImageModalModule;
